export const messages = {
  title: { id: 'admin/promotions.form.conditions.installments.title' },
  validation: {
    greaterThan: { id: 'admin/promotions.form.validation.greater-than' },
    maxLowerThanEqualsMin: {
      id: 'admin/promotions.form.validation.max-lower-than-equals-min',
    },
    minGreaterThanEqualsMax: {
      id: 'admin/promotions.form.validation.min-greater-than-equals-max',
    },
  },
  view: {
    title: {
      id: 'admin/promotions.form.conditions.installments.view.title',
    },
    interval: {
      id: 'admin/promotions.form.conditions.installments.view.interval-value',
    },
    times: {
      id: 'admin/promotions.form.conditions.installments.view.times',
    },
  },
  editor: {
    description: {
      id: 'admin/promotions.form.conditions.installments.editor.description',
    },
    min: {
      id: 'admin/promotions.form.conditions.installments.editor.min',
    },
    max: {
      id: 'admin/promotions.form.conditions.installments.editor.max',
    },
  },
}
